import { render, staticRenderFns } from "./CustomerDashboardCard.vue?vue&type=template&id=cd705e46&scoped=true&"
import script from "./CustomerDashboardCard.vue?vue&type=script&lang=js&"
export * from "./CustomerDashboardCard.vue?vue&type=script&lang=js&"
import style0 from "./CustomerDashboardCard.vue?vue&type=style&index=0&id=cd705e46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd705e46",
  null
  
)

export default component.exports